<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1000px;height: 30px; margin-top: 70px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/活动列表</span></div>
		<div class="list-Scroll">
			<div @click="activity(item)" v-for="(item) in list" :key="item.id" class="list-div" :class="`div-status-${ item.activityStatus }`">
				<p>{{item.activityName}}</p>
				<p>{{ item.startTime }} 至 {{ item.endTime }}</p>
				<div class="rotate-span" :class="`div-status-${ item.activityStatus }`">
					<span>{{ item.activityStatusName }}</span>
				</div>
			</div>
		</div>
		<el-dialog :close-on-click-modal="false" :show-close="false" :title="title" :visible.sync="dialogFormVisible" width="35%">
			<el-form>
				<div>
					<pre style="white-space:pre-line;text-align: left;">
						{{activityDescribe}}
					</pre>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="toActivity(currentitem)" type="primary">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { activityList, getImage } from '../api/service'
import bar from '@/components/bar.vue'

export default {
	data() {
		return {
			list: null,
			dialogFormVisible: false,
			activityDescribe: '',
			title: '',
			currentitem: null
		};
	},
	methods: {
		fetchData () {
			const params = {
				page_index: '1',
				page_size: '1000',
				staffId: this.$store.getters.id
			}
			activityList(params).then(response => {
				if (response.data.success === true) {
					this.list = response.data.data.list
				} 
			}).catch(() => {
				this.list = null
			})
		},
		toActivity (item) {
			this.dialogFormVisible = false
			const para = {
				activityId: item.id,
				activityName: item.activityName,
				activityLimit: item.activityLimit.toString(),
				surplusLimit: item.surplusLimit.toString()
			}
			this.$router.push({ path: 'Activitylist', query: para })
		},
		activity (item) {
			this.currentitem = item
			this.title = item.activityName
			this.activityDescribe = item.activityDescribe
			this.dialogFormVisible = true
		},
		image () {
			getImage().then(response => {
				if (response.data.success === true) {
					this.$store.dispatch('setImageUrl', response.data.data);
				} 
			}).catch(() => {
			})
		}
	},
	created() {
		this.fetchData()
		this.image()
	},
	components:{
		bar
	}
};
</script>

<style scoped>
.div-status-0 {
    background-color: #ff6600;
}
.div-status-1 {
    background-color: #ff6666;
}
.div-status-2 {
    background-color: #999999;
}
.div-status-3 {
    background-color: #999999;
}
a {
	text-decoration: none;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
p {
	padding-top: 15px;
	color: white;
}
.list-div {
	position: relative;
	width: 800px;
	height: 100px;
	margin: 0 auto;
	margin-top: 50px;
	cursor: pointer;
	transition: all 0.5s;
}
.list-div:hover {
	box-shadow: 0px 0px 14px 1px #b0b0b0;
	transform: translate(0, -5px);
}

.rotate-span {
	position: absolute;
	top: -2px;
	right: 28px;
	width: 30px;
	height: 100px;
	transform: rotate(-38deg);
}
.rotate-span span {
	line-height: 30px;
}

</style>
